// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2UpBt","row":"styles_row__2P-7Q"};